import { fromJS, List } from 'immutable';
import * as types from './actionTypes';

const initialState = fromJS({
  currentJobID: null,
  contacts: [],
  notes: [],
  attachedFiles: [],
  weather: null,
  meetingLocation: null,
  equipment: [],
  crew: [],
  people: [],
  lineTypes: [],
  activityLog: [],
});

const jobDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CONTACTS:
      return state.set('contacts', fromJS(action.contacts));

    case types.ADD_CONTACT:
      return state.update('contacts', (contacts) => contacts.push(action.contact));

    case types.UPDATE_CONTACT:
      return state.update('contacts', (contacts) =>
        contacts.map((contact) =>
          contact.get('uuid') === action.contact.get('uuid') 
          ? action.contact : contact
        )
      );

    case types.DELETE_CONTACT:
      return state.update('contacts', (contacts) =>
        contacts.filter((contact) => contact.get('uuid') !== action.uuid)
      );

    case types.SET_NOTES:
      return state.set('notes', fromJS(action.notes));

    case types.ADD_NOTE:
      return state.update('notes', (notes) => notes.push(action.note));

    case types.UPDATE_NOTE:
      return state.update('notes', (notes) =>
        notes.map((note) =>
          note.get('uuid') === action.note.get('uuid') 
          ? action.note : note
        )
      );

    case types.DELETE_NOTE:
      return state.update('notes', (notes) =>
        notes.filter((note) => note.get('uuid') !== action.uuid)
      );

    case types.SET_ATTACHED_FILES:
      return state.set('attachedFiles', action.files);

    case types.DELETE_ATTACHED_FILE:
      return state.update('attachedFiles', (files) =>
        files.filter((file) => file.get('filename') !== action.filename)
      );

    case types.SET_WEATHER:
      return state.set('weather', action.weather);

    case types.SET_MEETING_LOCATION:
      return state.set('meetingLocation', action.location);

    case types.SET_EQUIPMENT:
      return state.set('equipment', action.equipment);

    case types.UPDATE_EQUIPMENT:
      return state.update('equipment', (equipment) => {
        const existingIndex = equipment.findIndex(
          (eq) => eq.get('serial_number') === action.equipmentUpdate.serial_number
        );
        if (existingIndex >= 0) {
          return equipment.update(existingIndex, (eq) => eq.merge(fromJS(action.equipmentUpdate)));
        } else {
          return equipment.push(fromJS(action.equipmentUpdate));
        }
      });

    case types.DELETE_EQUIPMENT:
      return state.update('equipment', (equipment) =>
        equipment.filter((eq) => eq.get('serial_number') !== action.serialNumber)
      );

    case types.SET_CREW:
      console.log('crew', action.crew);
      return state.set('crew', action.crew);

    case types.UPDATE_CREW:
      return state.update('crew', (crew) => {
        const existingIndex = crew.findIndex(
          (c) => c.get('_id') === action.crewUpdate._id
        );
        if (existingIndex >= 0) {
          return crew.update(existingIndex, (c) => c.merge(fromJS(action.crewUpdate)));
        } else {
          return crew.push(fromJS(action.crewUpdate));
        }
      });

    case types.DELETE_CREW:
      return state.update('crew', (crew) =>
        crew.filter((c) => c.get('_id') !== action.serialNumber)
      );

    case types.SET_PEOPLE:
      return state.set('people', action.people);

    case types.UPDATE_PEOPLE:
      return state.update('people', (people) => {
        const existingIndex = people.findIndex(
          (p) => p.get('_id') === action.peopleUpdate._id
        );
        if (existingIndex >= 0) {
          return people.update(existingIndex, (p) => p.merge(fromJS(action.peopleUpdate)));
        } else {
          return people.push(fromJS(action.peopleUpdate));
        }
      });

    case types.DELETE_PEOPLE:
      return state.update('people', (people) =>
        people.filter((p) => p.get('_id') !== action.serialNumber)
      );

    case types.SET_LINE_TYPES:
      return state.set('lineTypes', fromJS(action.lineTypes));

    case types.ADD_LINE_TYPE:
      return state.update('lineTypes', (lineTypes) =>
        lineTypes.push(fromJS(action.lineType))
      );

    case types.UPDATE_LINE_TYPE:
      return state.update('lineTypes', (lineTypes) =>
        lineTypes.map((lineType) =>
          lineType.get('line_type') === action.lineType.line_type ? fromJS(action.lineType) : lineType
        )
      );

    case types.DELETE_LINE_TYPE:
      return state.update('lineTypes', (lineTypes) =>
        lineTypes.filter((lineType) => lineType.get('line_type') !== action.lineType)
      );

    case types.SET_ACTIVITY_LOG:
      return state.set('activityLog', action.activityLog.get('activities', List([])));

    case types.SET_CURRENT_JOB_ID:
      return state.set('currentJobID', action.jobID);

    case types.RESET_JOB_DASHBOARD:
      return initialState;

    default:
      return state;
  }
};

export default jobDashboardReducer;
